import Pqp from "../Pqp.js";
import SoundSingle from "./SoundSingle.js";

export default class Sounder {
	constructor(lAutoStart, callback, maxVolume) {
		this.aSound = new Array();
		this.preloaded = 0;
		this.lAutoStart = lAutoStart;
		this.callback = callback;
		this.maxVolume = 1;
		if (!Pqp.isNullOrEmpty(maxVolume)) {
			this.maxVolume = maxVolume;
		}
		this.volume = this.maxVolume;
		this.debugEvent = false;
		this.active = true;


		this.updateVolume();
	}

	add(id, path) {
		// Public
		for (var x = 0; x < this.aSound.length; x++) {
			if (this.aSound[x].id == id) {
				this.dispatchEvent(Sounder.ALL_SOUNDS_READY);
				//console.log("Warning! Il suono " + id + " esiste già!");
				return
			}
		}
		this.aSound.push(new SoundSingle(this, id, path, jQuery.proxy(this.eventHandler, this)));
		if (this.lAutoStart) {
			this.checkPreloadList();
		}
	}

	init() {
		// Public
		this.lAutoStart = true;
		this.checkPreloadList();
	}

	checkPreloadList() {
		if (this.preloaded < this.aSound.length) {
			if (!this.aSound[this.preloaded].isPreloading) {
				this.preloadNextSound();
			}
		} else {
			this.dispatchEvent(Sounder.ALL_SOUNDS_READY);
		}
	}

	trace(xVal, color) {
		// Trace controllato
		if (this.debugEvent) {
			if (Pqp.isNullOrEmpty(color)) {
				console.log(xVal);
			} else {
				console.log(xVal, color);
			}
		}
	}

	

	preloadNextSound() {
		this.aSound[this.preloaded].isPreloading = true;
		this.dispatchEvent(Sounder.START_PRELOADING_ONE_SOUND, this.aSound[this.preloaded]);

		this.aSound[this.preloaded].preload();

	}

	eventHandler(e, snd) {
		if (e == SoundSingle.PRELOAD_COMPLETE) {
			this.dispatchEvent(Sounder.ONE_SOUND_PRELOADED, this.aSound[this.preloaded]);
			this.preloaded++;
			this.checkPreloadList();
		}
		if (e == SoundSingle.SOUND_FINISHED_PLAYING) {
			this.dispatchEvent(Sounder.SOUND_FINISHED_PLAYING, snd);
		}
		if (e == SoundSingle.SOUND_LOOPING) {
			this.dispatchEvent(Sounder.SOUND_LOOPING, snd);
		}
	}

	updateVolume(lKill) {
		if (this.active) {
			this.volume = this.maxVolume;
		} else {
			this.volume = 0;
		}
		for (var x = 0; x < this.aSound.length; x++) {
			this.aSound[x].setVolume(this.volume, lKill);
		}
	}

	setStartTime(id, time) {
		let snd = this.getSoundById(id);
		snd.setStartTime(time);
  }
	getDuration(id) {
		let snd = this.getSoundById(id);
		//console.log(snd)
		return snd.getDuration();
  }

	getSoundById(id) {
		for (var x = 0; x < this.aSound.length; x++) {
			if (this.aSound[x].id == id) {
				return this.aSound[x];
			}
		}
		console.log("Warning! Non trovo il suono " + id + "!");
		return null;
	}


	play(id, lOneInstance, fadeIn, fadeOut,callback) {
		// Public (fadeout not supported)
		try {
			//debugger
			var snd = this.getSoundById(id);
			snd.play(lOneInstance, fadeIn, callback);
			this.updateVolume();
		} catch (e) {
			alert("Sorry something went wrong trying to play sound, please reload the game!");
		}
	}

	playLoop(id, fadeIn, fadeOut,quanti) {
		// Public (fadeout not supported)
		try {
			var snd = this.getSoundById(id);
			snd.playLoop(fadeIn, false, quanti);
			this.updateVolume();
		} catch (e) {
			alert("Sorry something went wrong trying to play sound, please reload the game!");
		}
	}

	stop(id) {
		// Public
		var snd = this.getSoundById(id);
		snd.stop();
		this.volume = this.maxVolume;
	}

	pause(id) {
		var snd = this.getSoundById(id);
		snd.pause();
	}


	resume(id) {
		var snd = this.getSoundById(id);
		//snd.play();
		snd.resume();
	}

	activate(lFlag) {
		// Public
		this.active = lFlag;
		this.updateVolume();
	}

	setVolume(vol) {
		// Public
		this.maxVolume = vol;
		this.updateVolume(true);
	}

	dispatchEvent(type) {
		// Funzione che si occupa di passare gli eventi alla funzione registrata
		var e = new Object();
		e.type = type;
		if (type == Sounder.ALL_SOUNDS_READY) {
			this.trace("Evt all sounds ready", 2);
		}
		if (type == Sounder.ONE_SOUND_PRELOADED) {
			e.sound = arguments[1];
			this.trace("Evt one sound preloaded: " + e.sound.id, 2);
		}
		if (type == Sounder.START_PRELOADING_ONE_SOUND) {
			e.sound = arguments[1];
			this.trace("Evt start preloading: " + e.sound.id, 2);
		}
		if (type == Sounder.SOUND_FINISHED_PLAYING) {
			e.sound = arguments[1];
			this.trace("Evt sound finished playing: " + e.sound.id, 2);
		}
		if (type == Sounder.SOUND_LOOPING) {
			e.sound = arguments[1];
			this.trace("Evt sound looping: " + e.sound.id, 2);
		}
		if (!Pqp.isNullOrEmpty(this.callback)) {
			this.callback.call(null, e);
		}
	}

	toggleVolume(lOn) {
		console.log("Volume attuale " + this.volume)
		this.active = lOn;
		for (var x = 0; x < this.aSound.length; x++) {
			var snd = this.aSound[x];
			if (lOn) {
				snd.volumeFadeIn();
			} else {
				snd.volumeFadeOut();
			}
		}
	}
}


Sounder.FADE_IN_TIME = 4;
Sounder.TOGGLE_FADE_IN_TIME = 2;
Sounder.TOGGLE_FADE_OUT_TIME = 2;

Sounder.ALL_SOUNDS_READY = "allSoundsReady";
Sounder.START_PRELOADING_ONE_SOUND = "startPreloadingOneSound";
Sounder.ONE_SOUND_PRELOADED = "oneSoundPreloaded";
Sounder.SOUND_FINISHED_PLAYING = "soundFinishedPlaying";
Sounder.SOUND_LOOPING = "soundLooping";

